var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.728516,
    width: 24.5443,
    height: 25.1272,
    rx: 12.2721,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2725 12.754C21.2725 12.1712 21.2257 11.5885 21.1319 11.0176H13.1719V14.3121H17.7322C17.5446 15.3706 16.935 16.3221 16.044 16.9168V19.0576H18.7638C20.3581 17.5709 21.2725 15.3706 21.2725 12.754Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1727 21.1271C15.447 21.1271 17.3696 20.3659 18.7647 19.0576L16.0449 16.9168C15.2829 17.4401 14.3099 17.7375 13.1727 17.7375C10.9688 17.7375 9.10481 16.227 8.43659 14.2051H5.63477V16.4173C7.06499 19.3074 9.98404 21.1271 13.1727 21.1271Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43654 14.2051C8.08479 13.1466 8.08479 11.9929 8.43654 10.9225V8.72217H5.63427C4.4266 11.1366 4.4266 13.991 5.63427 16.4054L8.43654 14.2051Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1727 7.39017C14.3802 7.36638 15.5408 7.83023 16.4083 8.67467L18.8233 6.22461C17.2875 4.7736 15.2712 3.97673 13.1727 4.00052C9.98404 4.00052 7.06499 5.83212 5.63477 8.72225L8.43659 10.9344C9.10481 8.90065 10.9688 7.39017 13.1727 7.39017Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.41171754e472e3ac96334d39960abbd8.svg";
export { ForwardRef as ReactComponent };